import Image from "@/components/AppImage";
import Link from "@/components/common/DashboardLink";
import { useAuth } from "@/context/AuthContext";
import { useMemo } from "react";
import { FaCog, FaSignOutAlt, FaSortDown } from "react-icons/fa";
import avatar_2 from "/public/images/avatar-2.png";
import avatar from "/public/images/avatar.png";

function formatDisplayName(user) {
  if (!user) return "User";
  const f = user.profile?.first_name?.trim?.() ?? "";
  const l = user.profile?.last_name?.trim?.() ?? "";
  const combined = [f, l].filter(Boolean).join(" ");
  if (combined) return combined;
  return user.email || "User";
}

const UserArea = () => {
  const { user, logout } = useAuth();
  const displayName = useMemo(() => formatDisplayName(user), [user]);
  const walletLabel = user?.user_id ?? "—";

  return (
    <div className="single-item user-area" onClick={(e) => e.stopPropagation()}>
      <div
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        className="profile-area dropdown d-flex align-items-center">
        <span className="user-profile">
          <Image src={avatar} alt="" />
        </span>
        <i className="ms-0">
          <FaSortDown />
        </i>
      </div>
      <div
        onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
        className={`main-area dropdown-menu user-content`}>
        <div className="head-area d-flex align-items-center">
          <div className="profile-img">
            <Image src={avatar_2} alt="" />
          </div>
          <div className="profile-head">
            <Link href="/account">
              <h5>{displayName}</h5>
            </Link>
            <p className="wallet-id">Wallet ID: {walletLabel}</p>
          </div>
        </div>
        <ul>
          <li className="border-area">
            <Link href="/account" className="d-flex align-items-center gap-2">
              <FaCog />
              Settings
            </Link>
          </li>
          <li>
            <button
              type="button"
              className="d-flex bg-transparent align-items-center gap-2 border-0 w-100 text-start"
              onClick={() => logout()}>
              <FaSignOutAlt />
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserArea;
